import Toast0 from './toast';
import Content from './Content.vue';
import Data from './Data.vue';
import Video from './Video.vue';
import Image from './Image.vue';
import NavigationBar from './NavigationBar.vue';
import CountryCode from './countryCode/CountryCode.vue';
import Share0 from './share/index';
// import Dialog0 from './dialog';

const components = {
  CountryCode,
  Content,
  Data,
  Image,
  Video,
  NavigationBar,
};
const prefix = 'Cfmoto';
const install = function install(app) {
  if (install.installed) return;
  Object.keys(components).forEach((key) => {
    const componentName = prefix + key;
    app.component(componentName, components[key]);
  });
  app.config.globalProperties.$share = Share0;
};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}
export const Toast = Toast0;
// export const Dialog = Dialog0;
export default {
  version: process.env.VERSION, // eslint-disable-line no-undef

  install,
  ...components,
};
